import { SearchState } from 'src/hooks/meilisearch/types/search-state';

export const bookingsQueryKeys = {
  all: ['bookings'] as const,
  lists: () => [...bookingsQueryKeys.all, 'list'] as const,
  list: (
    directoryToken: string,
    page: number,
    perPage: number,
    searchState?: SearchState,
  ) =>
    [
      ...bookingsQueryKeys.lists(),
      directoryToken,
      { page, perPage, ...searchState },
    ] as const,
};
